// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.field {
  margin-bottom: 1.5rem;
}

validation-error {
  padding-left: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./../shared/ng/interceptors/dialog/basic-auth-dialog/basic-auth-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;;AAEA;EACE,oBAAA;AACF","sourcesContent":[".field {\n  margin-bottom: 1.5rem;\n}\n\nvalidation-error {\n  padding-left: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
